import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

type CurrencyPairIconsProps = {
  size?: number
}

export const CurrencyPairIconsSkeleton: React.FC<CurrencyPairIconsProps> = ({
  size = 32,
}) => {
  return (
    <Icons $size={size}>
      <BaseSkeleton height={size} width={size} variant="circular" />
      <QuoteSkeleton height={size} width={size} variant="circular" />
    </Icons>
  )
}

const Icons = styled.div<{ $size: number }>`
  position: relative;
  display: inline-block;
  width: ${({ $size }) => $size * 2 - $size / 4}px;
  height: ${({ $size }) => $size}px;
`

const QuoteSkeleton = styled(Skeleton)`
  position: absolute;
  left: 0;
  /* background: #212121; */
`

const BaseSkeleton = styled(Skeleton)`
  position: absolute;
  right: 0;
  /* background: #212121; */
`
